// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-text_icon__V62vy"};